import { Contact } from '@features/contacts/types/contact'
import { createContactPersonsFromFormData } from '@features/contacts/utils/createContactPersonsFromFormData'
import { getBaseCustomerPayload } from '@features/contacts/utils/getBaseCustomerPayload'

import { MissingCustomerDetailsForm } from '../types/missingCustomerDetailsForm'

export const getUpdateCustomerPayload = (
  customerFormValues: MissingCustomerDetailsForm,
  organizationId?: string,
): Partial<Contact> => {
  const { isVatExempted } = customerFormValues
  const contactPersons = createContactPersonsFromFormData(customerFormValues)

  return {
    ...getBaseCustomerPayload(customerFormValues),
    contactPersons,
    isSalesTaxExempt: isVatExempted,
    organizationId,
  }
}
